import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import Button from 'components/Button';
import Message from 'components/Message';
import { makePath } from 'helpers/link-generation';
import messages from './Schedules.messages';

export const AddScheduleButton = ({ venueId, startDate }) => (
  <Link to={makePath.schedulesCreate({ venueId, startDate })}>
    <Message as={Button} styled="primary" message={messages.addClassSchedule} />
  </Link>
);

AddScheduleButton.propTypes = {
  venueId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  startDate: PropTypes.instanceOf(Date),
};
